import { Heading as ChakraHeading } from '@chakra-ui/react'
import { TextProps } from './utils'

const Section2 = ({ children, ...textProps }: TextProps) => (
  <ChakraHeading as="h3" fontSize="md" fontWeight={700} {...textProps}>
    {children}
  </ChakraHeading>
)

export { Section2 }
